import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate ,Outlet} from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import LoginPage from './components/Login/LoginPage';
import ClientInterface from './components/ClientInterface/ClientInterface';
import TesterInterface from './components/TesterInterface/TesterInterface';
import UnderConstructionDashboard from './components/ClientInterface/UnderConstructionDashboard';
import useAuth from './useAuth'; // Import the updated useAuth
import UserJoystickSettings from './components/SettingsInterface/SettingsInterface';
import OperatorManagement from './components/OperatorManagement/OperatorManagement'; // Assurez-vous que le chemin est correct


// App Component
const App = () => {
  const { isAuthenticated, login, logout } = useAuth();
  const ProtectedRoutes = ({ isAuthenticated, logout }) => {
    // If not authenticated, redirect to the login page
    if (!isAuthenticated) {
      return <Navigate to="/" replace />;
    }

    // If authenticated, render the protected components
    return (
      <>
        <Navbar logout={logout} />
        <Outlet />
      </>
    );
  };
  return (
    <Router>
      <Routes>
        {/* Public Route */}
        <Route path="/" element={<LoginPage login={login} />} />

        {/* Protected Routes */}
        <Route
          path="/app"
          element={<ProtectedRoutes isAuthenticated={isAuthenticated} logout={logout} />}
        >
          <Route path="client-dashboard" element={<UnderConstructionDashboard />} />
          <Route path="tester-interface" element={<TesterInterface />} />
          <Route path="user-settings" element={<UserJoystickSettings />} />
          <Route path="/app/operator-management" element={<OperatorManagement />} />
          <Route index element={<ClientInterface />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default App;